import { OrderStatus } from '@shared/model/order';
import { StatusOption } from './types';

export const ORDER_STATUSES: StatusOption[] = [
    {
        label: 'Приобретено',
        value: OrderStatus.Completed,
    },
    {
        label: 'Ожидает оплаты',
        value: OrderStatus.OnPayment,
    },
    {
        label: 'Отклонено',
        value: OrderStatus.OrderReject,
    },
    {
        label: 'Создано',
        value: OrderStatus.OrderForming,
    },
];
